import { Dto, IDName } from '@damofire/data-commons';
import { EmbeddedAsset } from '../asset/asset.dto';
import { EmbeddedIssue } from '../issue/issue.dto';
import { OrganizationInfos } from '@damofire/data-stas';

export interface Note extends Dto<string> {
  text?: string;
  asset?: EmbeddedAsset;
  issue?: EmbeddedIssue;
  inspection?: IDName;
  division?: IDName;
  organization?: IDName;
}

export interface Noteable extends OrganizationInfos {
  notes?: Note[];
  notesCount?: number;
}
